import { useEffect } from "react";

/* Dynamic per-route SEO — updates title, description, canonical, og:*, twitter:*, robots
 * Usage: <SEO title="..." description="..." path="/sat-master" image="..." noindex /> */
export default function SEO({
  title,
  description,
  path = "",
  image = "https://sat-akademie.com/brand/og-image.jpg",
  type = "website",
  noindex = false,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · SAT Akademie` : "SAT — Schweizer Akademie für Transformation";
    const url = `https://sat-akademie.com${path}`;

    document.title = fullTitle;

    const setMeta = (selector, attr, val) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace(/[[\]"]/g, "").split("=");
        el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };

    if (description) setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    if (description) setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    if (description) setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", image);

    // Noindex on preview host or when explicitly requested
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const isPreviewHost = /preview|localhost|127\.0\.0\.1|staging|emergentagent\.com/.test(host);
    const robotsVal = (noindex || isPreviewHost) ? "noindex, nofollow" : "index, follow";
    setMeta('meta[name="robots"]', "content", robotsVal);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image, type, noindex]);

  return null;
}
